
import { useStore } from '@/store'
import { defineComponent, onMounted, ref } from 'vue'
import { computed, watch } from 'vue'
import nameSettings from '@/settings/name-settings.json'
import FormOption from '@/components/Form/FormOption.vue'
import { ConfigurationActionTypes } from '@/store/modules/configuration/action-types'
import MobileAnimationService from '@/services/form/mobile-animation.service'
import Analytics from '@/singletons/analytics'

export default defineComponent({
  name: 'NameColorForm',
  components: {
    FormOption
  },
  setup() {
    const store = useStore()
    const configNonameId = computed(() => store.getters.configNonameId)
    const configNamethreadId = computed(() => store.getters.configNamethreadId)
    const options = computed(() => nameSettings.nameitoColors)
    let currentSelection = ref()
    const root = ref(null)
    let mobileAnimationService = new MobileAnimationService()

    // prettier-ignore
    watch(() => configNamethreadId.value, (config) => {
        currentSelection.value = config
      }
    )

    // prettier-ignore
    watch(() => root.value, (_) => {
        if(configNamethreadId.value) {
          currentSelection.value = configNamethreadId.value
          setTimeout(() => {
           mobileAnimationService.scrollToOption(root.value, currentSelection.value, '.name-dialog .scrolling-container')
        }, 250)
        }
        else {
           mobileAnimationService.scrollToOption(root.value, currentSelection.value, '.name-dialog .scrolling-container')
        }
      }
    )

    const onThreadClick = (option: any) => {
      store.dispatch(ConfigurationActionTypes.SET_CONFIG_NAEMTHREAD, option.id)
      Analytics.instance.sendNamethreadEvent(option.id)
      Analytics.instance.sendNameYesNo(true)
    }

    return {
      configNonameId,
      configNamethreadId,
      nameSettings,
      onThreadClick,
      currentSelection,
      options,
      root
    }
  }
})
